<template>
  <div>
    <v-layout wrap>
      <v-flex xs6>
        <h1 style="display: table">
          <span style="display: table-cell; vertical-align: middle">{{
            $t('Ketshop Setting')
          }}</span>
          <img style="height: 50px" src="/static/img/ketshop.png" />
        </h1>
      </v-flex>
      <v-flex xs6 class="text-xs-right">
        <template v-if="isEdit"></template>
        <template v-else>
          <v-btn fab small outline color="primary" @click="isEdit = true">
            <em class="fa fa-pencil-alt middle" />
          </v-btn>
        </template>
      </v-flex>
    </v-layout>
    <div class="form-control mb-3" v-if="isEdit">
      <div class="caption">ketshop market</div>
      <v-radio-group v-model="ketshopmarket" row hide-details>
        <v-radio :value="true" color="primary">
          <template slot="label">
            <img src="/static/img/assets/ketmarket.png" alt style="width: 100px" />
          </template>
        </v-radio>
        <v-radio :value="false" color="primary">
          <template slot="label">
            <img src="/static/img/assets/ketshop.png" alt style="width: 100px" />
          </template>
        </v-radio>
      </v-radio-group>
    </div>
    <div class="form-control mb-3" :class="{ 'has-error': errors.has('ketshopApiKey') }">
      <div class="caption">ketshop api key</div>
      <template v-if="isEdit">
        <input
          type="text"
          placeholder="ketshop api key"
          v-model="ketshop_api_key"
          v-validate="'required'"
          data-vv-name="ketshopApiKey"
          :data-vv-as="$t('ketshop api key')"
        />
        <span class="text-error" v-if="errors.has('ketshopApiKey')">
          {{ errors.first('ketshopApiKey') }}
        </span>
      </template>
      <div class="primary--text" v-else>{{ ketshop_api_key ? ketshop_api_key : '-' }}</div>
    </div>
    <div class="form-control mb-3" :class="{ 'has-error': errors.has('ketshopApiSecret') }">
      <div class="caption">ketshop api secret</div>
      <template v-if="isEdit">
        <input
          type="text"
          placeholder="ketshop api secret"
          v-model="ketshop_api_secret"
          v-validate="'required'"
          data-vv-name="ketshopApiSecret"
          :data-vv-as="$t('ketshop api secret')"
        />
        <span class="text-error" v-if="errors.has('ketshopApiSecret')">
          {{ errors.first('ketshopApiSecret') }}
        </span>
      </template>
      <div class="primary--text" v-else>{{ ketshop_api_secret ? ketshop_api_secret : '-' }}</div>
    </div>
    <div>
      <div class="caption">ketshop Status</div>
      <template v-if="isEdit">
        <label
          class="toggle-switch small"
          style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
        >
          <input type="checkbox" :checked="useketshop" @change="toggleUseKetshop()" />
          <span class="toggle-slider lever round"></span>
        </label>
      </template>
      <div v-else class="primary--text">
        <template v-if="useketshop">{{ $t('active') }}</template>
        <template v-else>{{ $t('inactive') }}</template>
      </div>
    </div>

    <div class="text-xs-center" v-if="isEdit">
      <v-btn outline color="grey" @click="cancelEdit">{{ $t('Cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="saveEdit">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  data: function () {
    return {
      isEdit: false,
      useketshop: false,
      ketshop_api_key: '',
      ketshop_api_secret: '',
      ketshopmarket: false
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      selectedBot: 'selectedBot'
    })
  },
  mounted: function () {
    this.useketshop = this.selectedBot.useketshop
    this.ketshop_api_key = this.selectedBot.ketshop_api_key
    this.ketshop_api_secret = this.selectedBot.ketshop_api_secret
    this.cached_useketshop = this.selectedBot.useketshop
    this.cached_ketshop_api_key = this.selectedBot.ketshop_api_key
    this.cached_ketshop_api_secret = this.selectedBot.ketshop_api_secret

    const regex = /ketmarket_/g
    const found_in_key = this.ketshop_api_key ? this.ketshop_api_key.match(regex) : ''
    const found_in_secret = this.ketshop_api_secret ? this.ketshop_api_secret.match(regex) : ''
    if (found_in_key || found_in_secret) this.ketshopmarket = true
  },
  methods: {
    toggleUseKetshop: function () {
      this.useketshop = !this.useketshop
    },
    cancelEdit: function () {
      this.isEdit = false
      this.useketshop = this.cached_useketshop
      this.ketshop_api_key = this.cached_ketshop_api_key
      this.ketshop_api_secret = this.cached_ketshop_api_secret
    },
    saveEdit: function () {
      var vm = this

      return new Promise((resolve, reject) => {
        vm.$validator.validateAll().then((result) => {
          if (!result) {
            // do stuff if not valid.
            vm.goToErrorInput()
            reject()
            return false
          }

          vm.$store.dispatch('loading')
          var data = {
            pageid: vm.selectedBot.pageid,
            useketshop: vm.useketshop,
            ketshop_api_key: vm.ketshop_api_key,
            ketshop_api_secret: vm.ketshop_api_secret
          }
          api.saveKetshopToken(data, function (error, response) {
            if (error) {
              vm.$store.dispatch('loading')
              reject(error)
            }
            vm.isEdit = false
            vm.cached_useketshop = vm.useketshop
            vm.cached_ketshop_api_key = vm.ketshop_api_key
            vm.cached_ketshop_api_secret = vm.ketshop_api_secret
            vm.$store.dispatch('updateKetshopToken', data)
            vm.$store.dispatch('loading')
            vm.$forceUpdate()
            resolve()
          })
        })
      })
    }
  },
  watch: {
    ketshopmarket: function (newVal, oldVal) {
      const regex = /ketmarket_/g
      const found_in_key = this.ketshop_api_key.match(regex)
      const found_in_secret = this.ketshop_api_secret.match(regex)

      if (!newVal) {
        let key = this.ketshop_api_key.split('ketmarket_')
        if (key.length > 0) {
          this.ketshop_api_key = key[key.length - 1]
        }

        let secret = this.ketshop_api_secret.split('ketmarket_')
        if (secret.length > 0) {
          this.ketshop_api_secret = secret[secret.length - 1]
        }
      } else {
        if (!found_in_key)
          this.ketshop_api_key = 'ketmarket_' + (this.ketshop_api_key ? this.ketshop_api_key : '')
        if (!found_in_secret)
          this.ketshop_api_secret =
            'ketmarket_' + (this.ketshop_api_secret ? this.ketshop_api_secret : '')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.center-text-trick {
  height: 50px;
  line-height: 50px;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/view/billing/KetshopSetting.vue